import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonIconComponent } from '@ui-kit/buttons';
import { AccordionModule } from 'primeng/accordion';

@Component({
    selector: 'accordion-singular',
    standalone: true,
    imports: [AccordionModule, TranslateModule, ButtonIconComponent],
    templateUrl: './accordion-singular.component.html',
    styleUrl: './accordion-singular.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionSingularComponent {
    collapsed = input<boolean>(false);
    header = input<string>('');
    refreshButton = input<{
        id: string;
        display: boolean;
        refreshButtonLabel: string;
        loading?: boolean;
    } | null>(null);

    class = input<string>('');

    onOpen = output<void>();
    onClose = output<void>();
    onRefresh = output<void>();
}
